<template>
  <div class="user-profile-card bg-white shadow-sm">
    <div class="text-center">
      <video-icon class="user-profile-card-icon" />
      <h5 class="font-weight-bold mt-4 mb-4">Team highlight</h5>
      <div v-if="editable" class="user-profile-card-edit">
        <b-button variant="link" class="btn-link-edit-gray" size="lg" @click.prevent="$emit('edit')">
          <edit-pen-icon :style="{fontSize: '1.5rem'}" />
        </b-button>
      </div>
    </div>
    <div>
      <video :key="video" width="100%" v-if="video" controls>
        <source :src="video" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<script>
import VideoIcon from '@/assets/images/green/video.svg'
import EditPenIcon from '@/assets/images/edit-pen.svg'

export default {
  name: 'Values',

  props: {
    video: {
      type: String
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  components: {
    VideoIcon,
    EditPenIcon
  }
}
</script>
